export default "__VITE_ASSET__CRL_SPkp__"